/**
 * Is this string actually a recurrence rule?
 *
 * The calendar expands a series with
 * `@common-components/schedule-picker/recurrence-utils.toRuleSet`, which does NOT
 * throw on a malformed string: it logs and returns a DEFAULT rule — weekly,
 * starting now. So a message carrying a corrupt `rruleset` does not disappear
 * from the calendar, it silently grows a weekly cadence nobody scheduled. Worse,
 * dragging one of those invented occurrences writes the fabricated rule back to
 * the document through the recurrence handler, turning a display artefact into a
 * real schedule.
 *
 * The guard is deliberately shallow: an RRULE is defined by its FREQ, so a string
 * without one cannot be expanded, whatever else it contains. Anything with a FREQ
 * still goes through the real parser, which handles the genuinely malformed cases
 * by its own rules.
 */
export function hasUsableRecurrenceRule(rruleset: string | undefined | null): boolean {
    if (typeof rruleset !== 'string') return false;
    return /FREQ=/i.test(rruleset);
}
